import { Box, Paper, Typography, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ThermostatIcon from "@mui/icons-material/Thermostat";
import AirIcon from "@mui/icons-material/Air";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import ScaleIcon from "@mui/icons-material/Scale";
import { vitalValueSx } from "../../../nurse-dashboard/vitalsThresholds";

const VitalItem = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  borderRadius: 8,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
}));

const VitalsPanel = ({ vitals, showHeader = true }) => {
  const vitalItems = [
    {
      icon: MonitorHeartIcon,
      label: "BP",
      value: vitals.bloodPressure,
      unit: "mmHg",
      vitalKey: "bp",
    },
    { icon: FavoriteIcon, label: "HR", value: vitals.heartRate, unit: "bpm", vitalKey: "hr" },
    {
      icon: ThermostatIcon,
      label: "Temp",
      value: vitals.temperature,
      unit: "°F",
      vitalKey: "temp",
    },
    {
      icon: WaterDropIcon,
      label: "SpO2",
      value: vitals.oxygenSaturation,
      unit: "%",
      vitalKey: "spo2",
    },
    { icon: AirIcon, label: "RR", value: vitals.respiratoryRate, unit: "/min", vitalKey: "rr" },
    { icon: ScaleIcon, label: "Weight", value: vitals.weight, unit: "kg", vitalKey: null },
  ];

  return (
    <Box>
      {showHeader && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
            Current Vitals
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Updated: {vitals.lastUpdated}
          </Typography>
        </Box>
      )}

      <Grid container spacing={1}>
        {vitalItems.map((item, idx) => {
          const IconComponent = item.icon;
          return (
            <Grid item xs={4} key={idx}>
              <VitalItem elevation={0}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    mb: 0.5,
                  }}
                >
                  <IconComponent sx={{ fontSize: 14, color: "primary.main" }} />
                  <Typography variant="caption" color="text.secondary">
                    {item.label}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, ...(item.vitalKey ? vitalValueSx(item.vitalKey, item.value) : {}) }}
                  >
                    {item.value}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {item.unit}
                  </Typography>
                </Box>
              </VitalItem>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default VitalsPanel;
